import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_FOURNISSEURS_REQUEST: 'FETCH_FOURNISSEURS_REQUEST',
    FETCH_FOURNISSEURS_SUCCESS: 'FETCH_FOURNISSEURS_SUCCESS',
    FETCH_FOURNISSEURS_FAILURE: 'FETCH_FOURNISSEURS_FAILURE',

    FETCH_SUGGESTIONS_FOURNISSEUR_REQUEST: 'FETCH_SUGGESTIONS_FOURNISSEUR_REQUEST',
    FETCH_SUGGESTIONS_FOURNISSEUR_SUCCESS: 'FETCH_SUGGESTIONS_FOURNISSEUR_SUCCESS',
    FETCH_SUGGESTIONS_FOURNISSEUR_FAILURE: 'FETCH_SUGGESTIONS_FOURNISSEUR_FAILURE',

    CLEAR_SUGGESTIONS_FOURNISSEUR: 'CLEAR_SUGGESTIONS_FOURNISSEUR',

    SET_FOURNISSEUR_VALUE: 'SET_FOURNISSEUR_VALUE',
    CLEAR_FOURNISSEUR_VALUE: 'CLEAR_FOURNISSEUR_VALUE'
};


/**
 * FETCH_FOURNISSEURS
 * ActionCreator pour la récupération des fournisseurs
 */
const fetchFournisseursRequest = () => ({ type: Actions.FETCH_FOURNISSEURS_REQUEST });
const fetchFournisseursSuccess = items => ({ type: Actions.FETCH_FOURNISSEURS_SUCCESS, items });
const fetchFournisseursFailure = error => ({ type: Actions.FETCH_FOURNISSEURS_FAILURE, error });



export const fetchFournisseurs = () => (dispatch, getState) => {
    if (getState().fournisseur.fournisseurs.isLoading) {
        return;
    }
    if (getState().fournisseur.fournisseurs.items.length > 0) {
        return;
    }
    return dispatch(_fetchFournisseurs());
};


const _fetchFournisseurs = () => async (dispatch) => {

    dispatch(fetchFournisseursRequest());

    try {
        let response = await axios.get('api/fournisseurs');
        dispatch(fetchFournisseursSuccess(response.data));
    } catch (error) {
        console.error('fetchFournisseurs : ', error);
        dispatch(fetchFournisseursFailure(error));
    }

};




/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsFournisseurRequest = (namespace) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_REQUEST}`
});
const fetchSuggestionsFournisseurSuccess = (namespace, fournisseurs) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_SUCCESS}`,
    fournisseurs
});
const fetchSuggestionsFournisseurFailure = (namespace, error) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_FAILURE}`,
    error
});

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsFournisseur = (namespace, searchValue) => async (dispatch) => {
    dispatch(fetchSuggestionsFournisseurRequest(namespace));

    try {
        let response = await axios.get('api/fournisseurs/suggestion?query=' + searchValue);

        dispatch(fetchSuggestionsFournisseurSuccess(namespace, response.data));

    } catch (error) {
        dispatch(fetchSuggestionsFournisseurFailure(namespace, error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_FOURNISSEUR
 */
export const clearSuggestionsFournisseur = (namespace, ) => ({ type: Actions.CLEAR_SUGGESTIONS_FOURNISSEUR });



/**
 * ActionCreator pour SET_FOURNISSEUR_VALUE
 */
export const setFournisseurValue = (namespace, value, selectedId) => ({ type: `${namespace}/${Actions.SET_FOURNISSEUR_VALUE}`, value, selectedId });

/**
 * ActionCreator pour CLEAR_FOURNISSEUR_VALUE
 */
export const clearFournisseurValue = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_FOURNISSEUR_VALUE}` });
